import React, { useState } from 'react';
import styled from 'styled-components';
import { AdminNavbar } from '../../app/adminNavbar';
import Sidebar from '../../app/adminSidebar/adminSidebar';
import { AdminFooter } from '../../app/adminFooter';
import { DashboardLayout, HeaderWrapper, MainContent, PageTitle } from './AdminLayout.styled';

const AdminLayout = ({ children, pageTitle, activeTab, rightHeader }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <DashboardLayout>
      <AdminNavbar isCollapsed={isCollapsed} />

      <Sidebar
        isCollapsed={isCollapsed}
        onToggleCollapse={handleToggleCollapse}
        activeTab={activeTab}
      />

      <MainContent isCollapsed={isCollapsed}>
        <HeaderWrapper>
          {pageTitle && (
            <PageTitle style={{ marginBottom: '24px', fontSize: '28px', fontWeight: '600' }}>
              {pageTitle}
            </PageTitle>
          )}
          {rightHeader && <div style={{ alignSelf: 'flex-start' }}>{rightHeader}</div>}
        </HeaderWrapper>
        {children}

        <AdminFooter />
      </MainContent>
    </DashboardLayout>
  );
};

export default AdminLayout;
